import { Dialog, DialogContent, IconButton, styled } from "@mui/material";
import React, { useRef, useState } from "react";
import { ResponseOptionsMetaData } from "../../../../../../types/misc";
import { MOBILE_SCREEN_SIZE } from "../../../../../AppNavigation/constants";
import SurveySelectRow from "./SurveySelectRow";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 7,
}));
const RowContainer = styled("div", {
  label: "SurveyImageSelectRowContainer",
})(({ theme }) => ({
  position: "relative",
  cursor: "pointer",
  flexDirection: "column",
  display: "flex",

  width: "100%",
  height: 280,
  [theme.breakpoints.down("md")]: {
    height: 200,
  },

  ".video_thumbnail": {
    [theme.breakpoints.down("md")]: {
      height: 200,
    },
    width: "100%",
    height: 280,
    objectFit: "cover",
    borderRadius: 8,

    "&.square": {
      aspectRatio: 1,
    },
    "&.rectangleHorizontal": {
      aspectRatio: 2,
    },
    "&.rectangleVertical": {
      aspectRatio: 0.5,
    },
  },

  ".play_overlay": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60px",
    height: "60px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "24px",
    transition: "background-color 0.3s ease",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
    },
  },

  alignItems: "center",
  ".row_text": {
    maxWidth: "100%",
    width: "100%",
    borderRadius: 8,
    objectFit: "cover",
    "&.square": {
      aspectRatio: 1,
    },
    "&.rectangleHorizontal": {
      aspectRatio: 2,
    },
    "&.rectangleVertical": {
      aspectRatio: 0.5,
    },

    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 16,
    },
  },
  ".indicator": {
    marginLeft: 10,
    width: 28,
    height: 28,
    objectFit: "contain",
    position: "absolute",
    right: -13,
    bottom: -13,
    zIndex: 1,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 18,
      height: 18,
      right: -4,
      bottom: -3,
    },
  },

  "&.disabled": {
    ".row_text": {
      opacity: 0.5,
    },
    ".video_thumbnail": {
      opacity: 0.5,
    },
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: "transparent",
    boxShadow: "none",
    maxWidth: "90vw",
    maxHeight: "90vh",
  },
}));

const VideoContainer = styled("div")({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  ".modal_video": {
    width: "100%",
    height: "auto",
    maxWidth: "800px",
    maxHeight: "600px",
    borderRadius: 8,
  },
});

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: -40,
  right: -40,
  color: "white",
  backgroundColor: "rgba(0, 0, 0, 0.5)",

  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
}));

const SurveyVideoSelect = ({
  mode,
  videoUrl,
  displaytext,
  onClick,
  selected = false,
  disabled = false,
}: {
  mode: ResponseOptionsMetaData["layoutMode"];
  videoUrl: string;
  displaytext: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleThumbnailClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!disabled) {
      setIsModalOpen(true);
      onClick(); // Call the original onClick handler
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Pause the video when modal closes
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <Container>
      <RowContainer
        className={disabled ? "disabled" : ""}
        onClick={handleThumbnailClick}
      >
        <video
          src={videoUrl}
          className={`${mode} video_thumbnail`}
          muted
          preload="metadata"
          style={{}}
          poster="" // You can add a poster image here
        />
        <div className="play_overlay">
          <PlayArrowIcon
            sx={{ width: 25, height: 25, color: "white", opacity: 0.7 }}
          />
        </div>
      </RowContainer>
      <SurveySelectRow
        text={displaytext}
        onClick={onClick}
        selected={selected}
        disabled={disabled}
      />

      <StyledDialog
        open={isModalOpen}
        onClose={handleCloseModal}
        maxWidth={false}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <DialogContent sx={{ padding: 0, position: "relative" }}>
          <VideoContainer>
            <video
              ref={videoRef}
              src={videoUrl}
              className="modal_video"
              controls
              autoPlay
            />
          </VideoContainer>
        </DialogContent>
      </StyledDialog>
    </Container>
  );
};

export default SurveyVideoSelect;
